// extracted by mini-css-extract-plugin
export default {"productCarousel":"V0-z"};